import SummerCampHero from "../../components/SummerCampHero";
// import SummerCampComponent from "../../components/SummerCamp";

export default function SummerCamp() {
  return (
    <div style={{ margin: 2, padding: 20, display: "flex", flexDirection: "column", gap: 24, alignItems: "center", minHeight: "60vh", justifyContent: "center" }}>
      {/* <SummerCampHero /> */}
      {/* <SummerCampComponent /> */}
      <div style={{ textAlign: "center" }}>
        <h2 style={{ color: "#333", marginBottom: 8, fontSize: "1.8rem" }}>पंजीकरण समाप्त</h2>
        <p style={{ color: "#666", fontSize: "1.1rem", letterSpacing: "0.03em" }}>Registrations are now closed</p>
      </div>
    </div>
  );
}
